export default "__VITE_ASSET__KztjEoT6__"